import classnames from 'classnames';
import React, { KeyboardEvent, useRef, useState } from 'react';
import { Overlay, Tooltip } from 'react-bootstrap';
import { Control, Controller, useFieldArray } from 'react-hook-form';
import crossIconFilled from 'v2/icons/crossIconFilledBlue.svg';
import { TagForm } from '../../DataProducts/models';
import FormLabel from '../FormLabel/FormLabel';
import styles from './inputTags.module.scss';

interface InputTagsProps {
  label?: string;
  error?: string | null;
  // TODO find type definition for this property
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  name: string;
  max?: number;
  required?: boolean;
  tooltip?: string;
}

const InputTags = ({
  label,
  error,
  control,
  name,
  max = 30,
  required,
  tooltip,
}: InputTagsProps) => {
  const [inputValue, setInputValue] = useState('');
  const { fields, remove, append } = useFieldArray({
    control,
    name,
  });
  const [showTooltip, setShowTooltip] = useState(false);
  const toolTipTarget = useRef(null);

  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    const tagExists = !!fields.find(
      (item) =>
        (item as unknown as TagForm).value.toLowerCase() ===
        inputValue.toLowerCase()
    );
    if (e.key === 'Enter') {
      e.preventDefault();
      setShowTooltip(false);
      if (!tagExists && inputValue && fields.length < max) {
        append({ value: inputValue });
      }
      setInputValue('');
    }
  };

  return (
    <div className={classnames('form-group')}>
      {label ? (
        <FormLabel label={label} required={required} error={error} />
      ) : null}
      {tooltip ? (
        <Overlay
          target={toolTipTarget.current}
          show={showTooltip}
          placement="top"
        >
          {(props) => (
            <Tooltip
              id={`tooltip-${name}`}
              {...props}
              className={styles.tooltip}
            >
              {tooltip}
            </Tooltip>
          )}
        </Overlay>
      ) : null}

      <input
        ref={toolTipTarget}
        className="form-control"
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.currentTarget.value);
          if (!e.currentTarget.value) {
            setShowTooltip(false);
          } else {
            setShowTooltip(true);
          }
        }}
        type="text"
        onKeyDown={onKeyDown}
        maxLength={64}
        disabled={fields.length >= max}
        aria-label={name}
        data-cy="tags-input"
      />
      <div className={styles.tagsList}>
        {fields.map((item, index) => (
          <Controller
            key={item.id}
            render={({ field }) => (
              <div className={styles.tag} data-cy="tag">
                <span {...field} className={styles.tagText}>
                  {field?.value}
                </span>
                <button
                  type="button"
                  onClick={() => remove(index)}
                  className="pl-3"
                >
                  <img src={crossIconFilled} alt="removeTag"></img>
                </button>
              </div>
            )}
            name={`${name}[${index}].value`}
            defaultValue={(item as unknown as TagForm).value}
            control={control}
          />
        ))}
      </div>
    </div>
  );
};

export default InputTags;
